import { Routes, Route } from "react-router-dom";
import { CartProvider } from "@/lib/cart";
import RootLayout from "@/web/components/layout/root-layout";
import Home from "@/web/pages/home";
import Services from "@/web/pages/services";
import About from "@/web/pages/about";
import FreeQuote from "@/web/pages/free-quote";
import ProductsIndex from "@/web/pages/products/index";
import ProductCategory from "@/web/pages/products/category";
import ProductDetail from "@/web/pages/products/detail";
import Cart from "@/web/pages/cart";
import Checkout from "@/web/pages/checkout";
import AccountIndex from "@/web/pages/account/index";
import AccountLogin from "@/web/pages/account/login";
import AccountRegister from "@/web/pages/account/register";
import AdminIndex from "@/web/pages/admin/index";
import AdminProducts from "@/web/pages/admin/products";
import AdminOrders from "@/web/pages/admin/orders";
import AdminCustomers from "@/web/pages/admin/customers";

export default function App() {
  return (
    <CartProvider>
      <Routes>
        <Route element={<RootLayout />}>
          <Route index element={<Home />} />
          <Route path="services" element={<Services />} />
          <Route path="about" element={<About />} />
          <Route path="free-quote" element={<FreeQuote />} />
          <Route path="products" element={<ProductsIndex />} />
          <Route path="products/:category" element={<ProductCategory />} />
          <Route path="products/:category/:slug" element={<ProductDetail />} />
          <Route path="cart" element={<Cart />} />
          <Route path="checkout" element={<Checkout />} />
          <Route path="account" element={<AccountIndex />} />
          <Route path="account/login" element={<AccountLogin />} />
          <Route path="account/register" element={<AccountRegister />} />
          <Route path="admin" element={<AdminIndex />} />
          <Route path="admin/products" element={<AdminProducts />} />
          <Route path="admin/orders" element={<AdminOrders />} />
          <Route path="admin/customers" element={<AdminCustomers />} />
        </Route>
      </Routes>
    </CartProvider>
  );
}
